import ErrorMessageModule from './error-message.module'

export default ErrorMessageModule
